import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core'
import gtag from 'src/utils/gtag'

import { IBanner } from '../../app'
import { IUser } from '../../page/admin/types'

export interface IBannerPromptCall {
  topic: string
  started_at: string
}

@Component({
  tag: 'onboarding-multi-step-modal',
})
export class OnboardingMultiStepModal {
  @Event() onboardingModalClosed: EventEmitter

  @Prop() banner: IBanner

  @Prop() currentUser: IUser
  @Prop() nextExternalCall: IBannerPromptCall
  @Prop() customizePageUrl: string
  @Prop() connectZoomUrl: string
  @Prop() startTestCallUrl: string
  @Prop() scheduleCallUrl: string
  @Prop() completedTutorialUrl: string
  @Prop() tutorialVersion = 1
  @Prop() skippedTutorialUrl: string
  @Prop() viewedTutorialStepUrl: string

  @Prop({ mutable: true }) step: 'auto_record' | 'education' | 'tutorial' = 'auto_record'
  @Prop({ mutable: true }) completedTutorial = false

  exitTutorial(completed: boolean) {
    this.completedTutorial ||= completed
    this.step = 'education'
  }

  componentWillLoad() {
    gtag.trackEvent('conversion')
  }

  render() {
    return (
      <Host>
        {this.step === 'education' && (
          <onboarding-education-modal
            onOnboardingEducationModalClosed={(e) => {
              e.stopPropagation()
              this.onboardingModalClosed.emit()
            }}
            onTutorial={() => {
              this.step = 'tutorial'
            }}
            banner={this.banner}
            currentUser={this.currentUser}
            customizePageUrl={this.customizePageUrl}
            nextExternalCall={this.nextExternalCall}
            connectZoomUrl={this.connectZoomUrl}
            startTestCallUrl={this.startTestCallUrl}
            scheduleCallUrl={this.scheduleCallUrl}
            completedTutorial={this.completedTutorial}
            tutorialVersion={this.tutorialVersion}
          />
        )}
        {this.step === 'tutorial' && (
          <onboarding-tutorial
            onClosed={(e) => {
              e.stopPropagation()
            }}
            onCompletedTutorial={() => this.exitTutorial(true)}
            onSkippedTutorial={() => this.exitTutorial(false)}
            tutorialVersion={this.tutorialVersion}
            viewedTutorialStepUrl={this.viewedTutorialStepUrl}
            completedTutorialUrl={this.completedTutorialUrl}
            skippedTutorialUrl={this.skippedTutorialUrl}
            tutorialContext='modal'
          />
        )}
      </Host>
    )
  }
}
